import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import BaseAdapter from '../BaseAdapter';

var LoginAdapter = /*#__PURE__*/function (_BaseAdapter) {
  _inherits(LoginAdapter, _BaseAdapter);

  var _super = _createSuper(LoginAdapter);

  function LoginAdapter() {
    _classCallCheck(this, LoginAdapter);

    return _super.apply(this, arguments);
  }

  _createClass(LoginAdapter, [{
    key: "beforeLogin",
    value:
    /**
     * @description 登录之前的一系列操作，包括是否检查登录，检查是否绑定手机号
     * @callback { Function } {code: number} number = 0 -> 正常状态 | !0 -> 登录失败
     * @param { needBindPhone } 需要绑定手机号，默认false
     */
    function beforeLogin(target, funcName, descriptor) {
      var oriFunc = descriptor.value;

      descriptor.value = function () {
        var _this = this,
            _arguments = arguments;

        var isBindPhone = _typeof(arguments[0]) === 'object' ? arguments[0]['needBindPhone'] : arguments[1],
            _callback = typeof arguments[0] === 'function' ? arguments[0] : _typeof(arguments[0]) === 'object' ? arguments[0]['callback'] : function () {},
            zz_bid = _typeof(arguments[0]) === 'object' ? arguments[0]['zz_bid'] : ''; // 绑定手机号函数


        var bindPhone = function bindPhone() {
          _this.isBindPhone(function (res) {
            if (res) return _callback({
              code: '0'
            });

            _this.bindPhone();
          });
        }; // 找靓机内不走下述逻辑


        if (typeof native !== 'undefined' && native["in"]('zlj')) {
          return oriFunc.call.apply(oriFunc, [this].concat(Array.prototype.slice.call(arguments)));
        } // zz_bid 如果有自定义id，则直接走授权登录


        if (zz_bid) return this.isLoginAsync({
          source: zz_bid,
          callback: function callback(res) {
            if (res) {
              return _callback({
                code: '0'
              });
            } else {
              return oriFunc.call.apply(oriFunc, [_this].concat(_toConsumableArray(_arguments)));
            }
          }
        }); // 如果已经登录，并不判断手机号

        if (this.isLogin() && !isBindPhone) return _callback({
          code: '0'
        }); // 如果已经登录，需要判断手机号，则绑定了手机号直接调callback，没有绑定手机号则去绑定手机号

        if (this.isLogin() && isBindPhone) return bindPhone(); // 如果没有登录并且不需要绑定手机号则走原来的登录方法

        if (!this.isLogin() && !isBindPhone) return oriFunc.call.apply(oriFunc, [this].concat(Array.prototype.slice.call(arguments))); // 如果没有登录需要判断手机号，则先登录然后再判断手机号

        if (!this.isLogin() && isBindPhone) {
          var cb = function cb(res) {
            if (+res.code === 0) return bindPhone();

            _callback({
              code: res.code
            });
          };

          if (typeof arguments[0] === 'function') arguments[0] = cb;
          if (_typeof(arguments[0]) === 'object' && arguments[0]['callback']) arguments[0]['callback'] = cb;
          return oriFunc.call.apply(oriFunc, [this].concat(Array.prototype.slice.call(arguments)));
        }

        return oriFunc.call.apply(oriFunc, [this].concat(Array.prototype.slice.call(arguments)));
      };
    }
  }]);

  return LoginAdapter;
}(BaseAdapter);

var loginAdapter = new LoginAdapter();
export function beforeLogin() {
  return loginAdapter.beforeLogin.apply(loginAdapter, arguments);
}